import Vue from "vue";
import Vuex from "vuex";
// import data from "@/assets/scannerocr/config.json";
// import dataEN from "@/assets/scannerocr/config_en.json";

Vue.use(Vuex);

// const defaultLang = "en"; // 默认语言，暂时并没有对外抛出

export default new Vuex.Store({
  state: {
    lang: 'en',
    data: {},
  },
  mutations: {
    updateData(state) {
      // let lang = "en";
      // if (navigator.languages && navigator.languages.length) {
      //   lang = navigator.languages[0];
      // } else {
      //   lang =
      //     navigator.userLanguage ||
      //     navigator.language ||
      //     navigator.browserLanguage ||
      //     "en";
      // }
      // let rawLang = lang;
      // if (lang.match("en")) {
      //   rawLang = "en";
      // } else if (lang.match("ms")) {
      //   rawLang = "ms-MY";
      // } else if (lang.match("zh")) {
      //   rawLang = "zh-CN";
      // } else if (lang.match("id")) {
      //   rawLang = "id-ID";
      // } else {
      //   rawLang = defaultLang;
      // }
      let rawLang = 'en'
      state.lang = rawLang,
      state.data = require(`@/assets/config/${rawLang}.json`);
    },
  },
  actions: {
    getData() {
      return new Promise((resolve, reject) => {
        try {
          // if (process.env.NODE_ENV === "development") {
          //   console.log(data);
          resolve(this.state.data);
          // } else {
          //   const dateTime  = new Date().getTime()
          //   fetch(`https://cdn.plinkoe.com/plinko2/config.json?=${dateTime}`)
          //     .then(res => res.json())
          //     .catch(error => console.error('Error:', error))
          //     .then(response => {
          //       resolve(response)
          //     })
          // }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  modules: {},
});
